import { render, staticRenderFns } from "./PassengerPriceBreakdown.vue?vue&type=template&id=c0309988&scoped=true&"
import script from "./PassengerPriceBreakdown.vue?vue&type=script&lang=ts&"
export * from "./PassengerPriceBreakdown.vue?vue&type=script&lang=ts&"
import style0 from "./PassengerPriceBreakdown.vue?vue&type=style&index=0&id=c0309988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0309988",
  null
  
)

export default component.exports